import getFlowContext from '../../lib/getFlowContext';
import { createClient, createStripeCustomer, isEmailAvailable } from '../../lib/api';
import { flags, setLoadingFlag } from '../../data/loading.redux';
import { errorTypes, setError, clearErrors } from '../../data/error.redux';
import { saveFields } from '../../data/client.redux';
import { setLoginStatus } from '../../data/ui.redux';
import convert from '../../lib/convert';
import { actions } from '../../lib/actions';
import config from '../../config';

class AccountSubmitter {
  constructor(details, redirect, dispatch) {
    this.details = details;
    this.publicDetails = this.sanitizeDetails();
    this.redirect = redirect;
    this.dispatch = dispatch;
  }

  sanitizeDetails() {
    const sanitized = { ...this.details };
    delete sanitized.password;
    return sanitized;
  }

  clearErrorsAndSetLoading() {
    this.dispatch(clearErrors([errorTypes.GENERIC, errorTypes.EMAIL_UNAVAILABLE]));
    this.setLoadingFlag();
  }

  setLoadingFlag() {
    this.dispatch(setLoadingFlag(flags.ACCOUNT_CREATION, true));
  }

  unsetLoadingFlag() {
    this.dispatch(setLoadingFlag(flags.ACCOUNT_CREATION, false));
  }

  setError(errorObject) {
    this.dispatch(setError(errorObject));
  }

  isEmailAddressAvailable = async () => {
    try {
      if (!(await isEmailAvailable(this.details.email))) {
        this.setError({ type: errorTypes.EMAIL_UNAVAILABLE });
        this.unsetLoadingFlag();

        return false;
      }
    } catch (e) {
      this.setError({
        message: 'An error occurred while verifying your email address. Please try again.',
      });
      this.unsetLoadingFlag();

      return false;
    }

    return true;
  };

  createAccount = async () => {
    let response;

    try {
      response = await createClient(this.details, this.dispatch);
    } catch (e) {
      this.setError({
        message: 'An error occurred while creating your account. Please try again.',
      });
      this.unsetLoadingFlag();

      return;
    }

    delete this.publicDetails.clientId;
    delete this.publicDetails.personId;

    this.dispatch(
      saveFields({
        clientId: response.data.clientId,
        personId: response.data.personId,
        ...this.publicDetails,
      }),
    );

    try {
      // Track clientId as part of the Conversion call
      // The later call to createStripeCustomer after this depends on a clientId being
      // present on a Salesforce lead object in order to succeed, so we await this
      await this.trackNewAccountDetails({
        clientId: response.data.clientId,
        personId: response.data.personId,
      });
    } catch (e) {
      // Swallow the error so we don't block user progression
    }

    await createStripeCustomer(response.data.clientId);

    this.dispatch(setLoginStatus(true));
    this.unsetLoadingFlag();

    window.location.assign(
      `${config.APP_URL}/client/${response.data.clientId}/redirect?redirect=self_onboarding`,
    );
  };

  trackNewAccountDetails = async ({ clientId, personId }) =>
    convert(actions.CREATED_BENCH_ACCOUNT, {
      ...this.publicDetails,
      clientId,
      userId: personId,
    }).catch(() => {
      this.dispatch(setLoadingFlag(flags.ACCOUNT_CREATION, false));
      this.setError({ type: errorTypes.POST_ERROR });
    });
}

export default AccountSubmitter;
